import { createFileRoute } from '@tanstack/react-router'
import EditionUnpublish from 'Edition/components/sections/Publish/EditionUnpublish'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/unpublish')({
    component: EditionUnpublish,
})
